import { render } from "./numberPool.vue?vue&type=template&id=1864cc69&scoped=true"
import script from "./numberPool.vue?vue&type=script&lang=js"
export * from "./numberPool.vue?vue&type=script&lang=js"

import "./numberPool.vue?vue&type=style&index=0&id=1864cc69&scoped=true&lang=css"
import "./numberPool.vue?vue&type=style&index=1&id=1864cc69&lang=css"
script.render = render
script.__scopeId = "data-v-1864cc69"

export default script